import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
/**
 * Specify the properties available in an event in {@link TrackingEvent}.
 */
function _createInteractionEventTracker(key, defaultProperties) {
  const track = properties => {
    getUsageTracker().track(key, Object.assign({}, defaultProperties, properties));
  };

  // If we use this function, we don't need to specify properties that are otherwise required as they are handled by the tracker library when creating the tracker. See {@link _UsageTracker.lastKnownEventProperties}
  track.withLastKnownEventProperties = properties => {
    getUsageTracker().track(key, Object.assign({}, defaultProperties, properties));
  };
  return track;
}
export const trackPageView = _createInteractionEventTracker('pageView', {});
export const trackAdditionalUnitsPicker = _createInteractionEventTracker('additional-units-picker', {});
export const trackClickedLink = _createInteractionEventTracker('clicked-link', {
  action: 'clicked link'
});
export const trackModalInteraction = _createInteractionEventTracker('modal-interaction', {});
export const trackNavigationClick = _createInteractionEventTracker('navigation-click', {});
export const trackTalkToSalesClick = _createInteractionEventTracker('talk-to-sales-click', {
  action: 'click talk to sales'
});
export const trackBuyButtonClick = _createInteractionEventTracker('buy-button-click', {
  action: 'clicked buy button'
});
export const trackProductClick = _createInteractionEventTracker('product-click', {});
export const trackButtonClick = _createInteractionEventTracker('button-click', {
  action: 'click button'
});
export const trackScrollInteraction = _createInteractionEventTracker('scroll-interaction', {});
export const trackFaqInteraction = _createInteractionEventTracker('faq-interaction', {});
export const trackHoverInteraction = _createInteractionEventTracker('hover-interaction', {
  action: 'hovered'
});
export const trackBannerInteraction = _createInteractionEventTracker('banner-interaction', {});
export const trackCurrencyPickerInteraction = _createInteractionEventTracker('currency-picker-interaction', {});
export const trackTermSelectorInteraction = _createInteractionEventTracker('term-selector-interaction', {});
export const trackCommunicationMethodsInteraction = _createInteractionEventTracker('communication-methods-interaction', {});
export const trackPlanBuilderInteraction = _createInteractionEventTracker('plan-builder-interaction', {});
export const trackFeatureTableInteraction = _createInteractionEventTracker('feature-table-interaction', {});
export const trackSignupButtonClick = _createInteractionEventTracker('signup-button-click', {
  action: 'clicked signup button'
});
export const trackTrialButtonClick = _createInteractionEventTracker('trial-button-click', {
  action: 'clicked trial button'
});
export const trackTooltipInteraction = _createInteractionEventTracker('tooltip-interaction', {});
export const trackVideoInteraction = _createInteractionEventTracker('video-interaction', {});